import React, { useState } from 'react'
import './style.css'
import Link from './link'
import { useCountContext } from "../../utils/global";

function Index() {
  const [global, dispatch] = useCountContext();
  const [points, setPoints] = useState({});
  const [source, setSource] = useState({});
  const frames = document.querySelectorAll('.frame');
  const menus = document.querySelectorAll('.menuList');
  window.onscroll = (() => {
    const trace = document.getElementById('trace').getBoundingClientRect().y
    const sort = document.getElementById('sort').getBoundingClientRect().y
    const enigma = document.getElementById('enigma').getBoundingClientRect().y
    // const clone = document.getElementById('clone').getBoundingClientRect().y
    // const travel = document.getElementById('travel').getBoundingClientRect().y
    const mtg = document.getElementById('mtg').getBoundingClientRect().y
    setSource({
      trace: Math.abs(trace) < window.innerHeight / 2 ? 'active' : '',
      sort: Math.abs(sort) < window.innerHeight / 2 ? 'active' : '',
      enigma: Math.abs(enigma) < window.innerHeight / 2 ? 'active' : '',
      // clone: Math.abs(clone) < window.innerHeight / 2 ? 'active' : '',
      // travel: Math.abs(travel) < window.innerHeight / 2 ? 'active' : '',
      mtg: Math.abs(mtg) < window.innerHeight / 2 ? 'active' : '',
    })
  })

  const handler = (e) => {
    const name = e.target.getAttribute('name');
    const data = e.target.getAttribute('data');
    const num = parseInt(data) * 0.1;
    const href = e.target.getAttribute('href')
    window.location.href = href
    dispatch({
      type: 'hover',
      name: name
    })
    const rect = e.target.getBoundingClientRect();
    const element = document.getElementById(`tip${name}`);
    const tip = element.getBoundingClientRect();

    setPoints({
      x0: rect.left,
      x1: rect.right,
      y1: rect.bottom,
      x2: tip.left,
      y2: (tip.bottom - tip.top) * (0.8 - num) + tip.top,
      display: 'block'
    })
  }
  const handleOut = () => {
    // setSource('')
    setPoints({
      ...points,
      display: 'none'
    })
    dispatch({
      type: 'mouseOut'
    })
  }

  const handleOpen = (e) => {
    if (!global.doorOpen) {
      dispatch({
        type: 'open',
        left: 'doorL',
        right: 'doorR',
      });
      setPoints({
        ...points,
        display: 'none'
      })
      setTimeout(() => {
        dispatch({
          type: 'home'
        })
      }, 2000);
    }
  }

  return (
    <div>
      <ul className='projects'>
        <h2>Projects</h2>
        <div className={global.project}>
          <Link source={source} name='trace' tipData={3} title="Contact Tracer"
            handler={handler} handleOut={handleOut} handleOpen={handleOpen} />
          <Link source={source} name='sort' tipData={2} title='Sorting Visualiser'
            handler={handler} handleOut={handleOut} handleOpen={handleOpen} />
          <Link source={source} name='enigma' tipData={4} title='Enigma Machine'
            handler={handler} handleOut={handleOut} handleOpen={handleOpen} />
          {/* <Link source={source} name='clone' tipData={0} title='YouTube Clone'
            handler={handler} handleOut={handleOut} handleOpen={handleOpen} />
          <Link source={source} name='travel' tipData={0} title='Top Travels'
            handler={handler} handleOut={handleOut} handleOpen={handleOpen} /> */}
          <Link source={source} name='mtg' tipData={1} title='MTG Library'
            handler={handler} handleOut={handleOut} handleOpen={handleOpen} />
          <span>More to come...</span>
        </div>
      </ul>
      <svg id='svgLine' style={{ display: points.display }} >
        <path d={`M${points.x0} ${points.y1} L${points.x1} ${points.y1} L${points.x2} ${points.y2}`} />
      </svg>
    </div>
  )
}

export default Index
